export default __webpack_public_path__ + "static/char-v-52-ja-9f2a170528ba92493d66ddbb9694bc8c.mp4";